import { FC, useCallback, useState } from 'react'

import { IWarnings } from 'bank-bsa-reporting/src/routes/CTR/List'
import { Transactions, Warnings } from 'bank-bsa-reporting/src/routes/CTR/components'
import { CTRTransaction } from 'bank-bsa-reporting/src/types'
import { Ctrs } from 'commons/types/DTO/bank/alerts/ctrs'
import { TableDataQa } from 'commons/types/enums'
import { Layer } from 'ui/components/Layer'
import { PageSection, PageSectionFace } from 'ui/components/Page'
import { Table } from 'ui/components/Table'
import { useAlertsContext } from '~bank-alerts/context'

import { columns } from './columns'

export const CTRsTable: FC = () => {
  const { data, isTableLoading, onPageChange } = useAlertsContext()

  const {
    form: { CTRsPage, CTRsSize },
    showCTRs,
    showCTRsTotalCount
  } = data

  const [modalItem, setModalItem] = useState<{ transactions: CTRTransaction[]; ctrId: number; ctrName: string }>({
    transactions: [],
    ctrId: 0,
    ctrName: ''
  })
  const [warnings, setWarnings] = useState<IWarnings>({
    warnings: null,
    warningsType: null
  })

  const onShowWarnings = useCallback(
    (warningsData: string, warningsType: string) =>
      setWarnings({
        warningsType,
        warnings: warningsData
      }),
    []
  )

  const onClose = useCallback(() => setModalItem({ transactions: [], ctrId: 0, ctrName: '' }), [])

  const onSetWarnings = useCallback((newWarnings: IWarnings) => setWarnings(newWarnings), [])

  const onSetModalItem = useCallback(
    (newModalItem: { transactions: CTRTransaction[]; ctrId: number; ctrName: string }) => setModalItem(newModalItem),
    []
  )

  const handlePageChange = useCallback(
    (page: number, size: number) => {
      onPageChange(page, size, 'CTRs')
    },
    [onPageChange]
  )

  return (
    <PageSection face={PageSectionFace.PRIMARY} title="CTRs with FinCEN warnings" anchor="ctr">
      <Warnings
        warnings={warnings}
        onClose={() =>
          onSetWarnings({
            warningsType: null,
            warnings: null
          })
        }
      />
      <Transactions
        onClose={onClose}
        transactions={modalItem.transactions}
        ctrId={modalItem.ctrId}
        ctrName={modalItem.ctrName}
      />
      <Layer rounded shadowed stretch>
        <Table<Ctrs>
          dataQa={TableDataQa.BP_ALERTS_CTRS}
          columns={columns({
            onShowTransactions: onSetModalItem,
            onShowWarnings
          })}
          dataSource={showCTRs.map((el) => ({
            item: el
          }))}
          loading={isTableLoading('CTRs')}
          pagination={{
            page: CTRsPage || 1,
            size: CTRsSize || 10,
            onChange: handlePageChange,
            total: showCTRsTotalCount
          }}
        />
      </Layer>
    </PageSection>
  )
}
